'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _compact = require('lodash/compact');

var _compact2 = _interopRequireDefault(_compact);

require('./Spinner.css');

var _spinner = require('../images/spinner.gif');

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 60 : _ref$size,
      className = _ref.className,
      _ref$global = _ref.global,
      global = _ref$global === undefined ? false : _ref$global;

  return _react2.default.createElement(
    'div',
    { className: global ? (0, _compact2.default)(['spinner', 'spinner--global', className]).join(' ') : (0, _compact2.default)(['spinner', className]).join(' ') },
    _react2.default.createElement('img', { style: {
        width: size,
        height: size
      }, src: _spinner2.default, alt: '' })
  );
};

exports.default = Spinner;